<div *ngIf="mode != 'O'" class="page-header border-bottom">
    <h3>Bulletin</h3>
</div>
<div class="container" id="modal_size">
    <div id="fade"></div>
    <div id="modal">
        <img style="margin-bottom:10px;" id="loader" src="/Cache/images/icon_load.gif" /><br />
        <label><strong>Please wait while the bulletin loads...</strong></label>
    </div>
    <div class="row" *ngIf="mode != 'O' && reqID != null"><a class="btn btn-primary" [href]="applicantDetailUrl"><span class="oi oi-chevron-left"></span> Back</a></div>
    <button class="btn btn-primary" style="cursor: pointer" (click)="goBack()" *ngIf="mode != 'O' && reqID == null && previousUrl ==''"><span class="oi oi-chevron-left"></span> Back</button>
    <a class="btn btn-primary" [href]="previousUrl" *ngIf="mode != 'O' && reqID == null  && previousUrl !=''"><span class="oi oi-chevron-left"></span> Edit</a>
    <a class="btn btn-success" [href]="dashboard" *ngIf="mode != 'O' && reqID == null && previousUrl !=''"><span class="oi oi-chevron-left"></span> Go to Dashboard</a>
    <button class="btn btn-primary" *ngIf="mode == 'O'" style="cursor:pointer;" (click)="goBack()"><span class="oi oi-chevron-left"></span> Back</button>
    <div *ngIf="alert && (!signed || !read)" class="alert alert-warning" style="margin-top:15px;">{{alert}}</div>
    <div class="card mx-auto border" style="margin-top:25px;width:330px;" *ngIf="signed || read">
        <div class="card-body">
            <div *ngIf="signed">
                <strong>Signed By:</strong> {{name}}<br />
                <div><strong>Date Signed:</strong> {{date}}<hr /></div>
                <div><strong>Signature:</strong> <img [src]="bulletin.img" style="height:50px;width:200px;" /></div>
            </div>
            <div *ngIf="read">
                <strong>Acknowledged By:</strong> {{name}}<br />
                <div><strong>Date Acknowledged:</strong> {{date}}</div>
            </div>
        </div>
    </div>
    <br />
    <div *ngIf="bulletinID != null && !bulletinLoading">
        <div class="modus-content">
            <h1>{{bulletin.BulletinHeadline}}</h1>
        </div>
        <hr />
        <div id="bulletinHeaderImage" style="margin-bottom: 20px;" *ngIf="bulletin.BulletinThumbFileAttachmentID != null">
            <img class="img-fluid" style="max-height: 150px;" [src]="thumbnailUrl" />
        </div>
        <quill-view [content]="bulletinBody"></quill-view>
        <div *ngIf="files != null && files.length > 0">
            <hr style="margin-top:10px;" />
            <strong>Attachments:</strong>
            <div *ngIf="bulletin.EmbedAttachmentInPage && files.length > 1">
                <ng-select style="width: 50%;"
                           bindLabel="AttachmentFileName"
                           [searchable]="true"
                           [(ngModel)]="formData.selectedAttachment"
                           (change)="loadPreview()"
                           [clearable]=false
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let fileInfo of files" [value]="fileInfo">{{fileInfo.AttachmentFileName}}</ng-option>
                </ng-select>
            </div>
            <div *ngFor="let file of files" style="margin-bottom: 10px;">
                <a *ngIf="!bulletin.EmbedAttachmentInPage && !bulletin.BulletinIsSecure" (click)="downloadFile(file.FileAttachmentID)" [href]="downloadUrl">
                    {{file.AttachmentFileName}}
                </a>
            </div>
        </div>
        <div class="content-wrapper" *ngIf="bulletin.EmbedAttachmentInPage && selectedFileIsViewable">
            <ejs-pdfviewer id="pdfViewer"
                           [serviceUrl]='service'
                           [documentPath]=''
                           [enableFormFields]='true'
                           [enablePrint]="true"
                           [enableFormFieldsValidation]='true'
                           [printMode]="printMode"
                           (documentLoad)="documentLoaded($event)"
                           (downloadStart)="documentStartDownload($event)"
                           (downloadEnd)="documentEndDownload($event)"
                           (printStart)="documentStartPrint($event)"
                           (printEnd)="documentEndPrint($event)"
                           [enableFormDesignerToolbar]='false'
                           [enableDownload]="true"
                           [isSignatureEditable]="false"
                           style="height:640px;display:block">
            </ejs-pdfviewer>
        </div>
        <div id="pdfDiv">
            <a *ngIf="selectedAttachmentLink && !selectedFileIsViewable" 
               [href]="selectedAttachmentLink" 
               target="_blank">
                {{ formData.selectedAttachment.AttachmentFileName }}
            </a>
        </div>
    </div>


    <div class="card" *ngIf="mode != 'O'" [hidden]="!(bulletin.BulletinMode == 'S' && bulletin.DateSigned == null)" style="overflow-x:auto;">
        <div class="card-header bg-light" *ngIf="bulletin.BulletinSignatureText != null && bulletin.BulletinSignatureText != ''" style="word-break:break-word;">{{bulletin.BulletinSignatureText}}</div>
        <div class="card-header bg-light" *ngIf="bulletin.BulletinSignatureText == null || bulletin.BulletinSignatureText == ''">I have agreed to submit this acknowledgement by electronic means. I also certify that I understand that an electronic signature has the same legal effect and can be enforced in the same way as a written signature.</div>
        <div class="card-body" [style.width.px]="550" style="background-color:#d4d4d4;border:1px solid black;border-radius:5px;">
            <div class="alert alert-info" style="margin:10px;" *ngIf="showClickMsg">Press "Clear" before generating your signature image.</div>
            <div class="m-signature-pad">
                <div class="m-signature-pad--body" [ngClass]="{ 'inValidSign': redBorder == true}" [hidden]="!(bulletin.BulletinMode == 'S' && bulletin.DateSigned == null &&  submitSignImg == null)">
                    <ngx-signaturepad [width]="510" [height]="150" #signaturePad></ngx-signaturepad>
                </div>
                <div *ngIf="bulletin.BulletinMode == 'S' && bulletin.DateSigned == null && submitSignImg != null" style="background-color:white;border:1px solid black">
                    <img [src]="submitSignImg" [style.max-width.px]="panelWidth - 50" />
                </div>
                <div class="m-signature-pad--footer">
                    <div style="text-align: center;font-size: 12px;">Sign above</div>
                    <button type="button" class="btn btn-outline-dark" (click)="clear()">Clear</button>
                    <button type="button" class="btn btn-outline-dark" (click)="clickSign('full')" *ngIf="enableCheckboxSign && !hideClick">Generate Signature</button>
                    <button type="button" class="btn btn-outline-dark float-right" (click)="submit()">Submit</button>
                </div>
            </div>
        </div>
    </div>

    <div class="card" *ngIf="mode == 'O'" [hidden]="!((bulletin.BulletinMode == 'S' || bulletin.BulletinMode == 'U'))" style="overflow-x:auto;">
        <div class="card-body" [style.width.px]="550" style="background-color:#d4d4d4;border:1px solid black;border-radius:5px;" *ngIf="bulletin.DateSigned == null">
            <div class="alert alert-info" style="margin:10px;" *ngIf="showClickMsg">Press "Clear" before generating your signature image.</div>
            <div class="m-signature-pad" [hidden]="!((bulletin.BulletinMode == 'S' || bulletin.BulletinMode == 'U') && bulletin.DateSigned == null)">
                <div class="m-signature-pad--body" [ngClass]="{ 'inValidSign': redBorder == true}" [hidden]="submitSignImg != null">
                    <ngx-signaturepad [width]="510" [height]="150" #signaturePad></ngx-signaturepad>
                </div>
                <div *ngIf="submitSignImg != null" style="background-color:white;border:1px solid black">
                    <img [src]="submitSignImg" [style.max-width.px]="panelWidth - 50" />
                </div>
                <div class="m-signature-pad--footer">
                    <div style="text-align: center;font-size: 12px;">Sign above</div>
                    <button type="button" class="btn btn-outline-dark" (click)="clear()">Clear</button>
                    <button type="button" class="btn btn-outline-dark" (click)="clickSign('full')" *ngIf="enableCheckboxSign && !hideClick">Generate Signature</button>
                    <button type="button" class="btn btn-outline-dark float-right" (click)="submitON()">Submit</button>
                    <div class="alert alert-warning" style="margin:10px;word-break:break-word;" *ngIf="bulletin.BulletinSignatureText != null && bulletin.BulletinSignatureText != ''">{{bulletin.BulletinSignatureText}}</div>
                    <div class="alert alert-warning" style="margin:10px;" *ngIf="bulletin.BulletinSignatureText == null || bulletin.BulletinSignatureText == ''">By signing above, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.</div>
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="card-body" *ngIf="bulletin.DateSigned != null && bulletin.HasSecondReviewStep && bulletin.SecondStepSubmitDate == null && 
             (bulletin.BulletinModeLabel == 'Onboarding Document' || (bulletin.BulletinMode == 'R' || bulletin.BulletinMode == 'S')) && bulletin.HasOnboardDocViewPermission">
            <button type="button" class="btn btn-success" (click)="secondSubmit()">Submit</button>
        </div>
    </div>

    <div class="card border" *ngIf="(bulletin.BulletinMode == 'R' || (bulletin.BulletinMode == 'T' && mode == 'O')) && !read">
        <div class="card-header bg-light" *ngIf="bulletin.BulletinSignatureText != null && bulletin.BulletinSignatureText != ''">{{bulletin.BulletinSignatureText}}</div>
        <div class="card-header bg-light" *ngIf="bulletin.BulletinSignatureText == null || bulletin.BulletinSignatureText == ''">I have agreed to submit this acknowledgement by electronic means. I also certify that I understand that an electronic signature has the same legal effect and can be enforced in the same way as a written signature.</div>
        <div class="card-body">
            <button type="button" class="btn btn-success" (click)="mode == 'O' ? sendONAcknowledge() : sendAcknowledge()" *ngIf="(bulletin.BulletinMode == 'R' || (bulletin.BulletinMode == 'T' && mode == 'O')) && !read">Acknowledge</button>
        </div>
    </div>
</div>